<template>
    <div className="home">
        <ViewResults/>
    </div>
</template>

<script>
// @ is an alias to /src
import ViewResults from '@/components/ViewResults.vue'

export default {
    name: 'ResultsView',
    components: {
        ViewResults
    }
}
</script>
